import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@parleyride/supabase';

/**
 * Whether the signed-in user is a driver.
 *
 * Goes through the `my_profile()` RPC rather than reading `profiles`
 * directly: `20260828000002` column-scopes the cross-user SELECT grant on
 * `profiles`, and own-row reads belong on the RPC so they keep working when
 * more columns move behind it. The RPC is `auth.uid()`-only, so `userId` is
 * accepted purely to keep the call sites unchanged and is asserted against
 * the row that comes back.
 */
export async function fetchUserIsDriver(
  supabase: SupabaseClient<Database>,
  userId: string,
): Promise<boolean> {
  try {
    const { data: profile, error } = await supabase.rpc('my_profile');

    if (error) throw error;
    if (!profile || profile.id !== userId) return false;
    return !!profile.is_driver;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return false;
  }
}
